module.exports = __webpack_public_path__ + "img/Kb.6ad0049b.png";